module.exports = __webpack_public_path__ + "img/portfolio-guide-modal-illustration-fr5.2c58093.png";